import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useDeleteWatchlist = () => {
  const apiClient = useApiClient(ClientApiClient)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number): Promise<void> => apiClient.deleteWatchlist(id),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['trade', 'dxtrade', 'watchlists'] })
    },
  })
}
